// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Select_wrapper__22Otd","labelWrapper":"Select_labelWrapper__37Jns","icon":"Select_icon__1j7UC"};